"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * A scrolling container with horizontally arranged sub groups.
         */
        var Panorama = /** @class */ (function (_super) {
            __extends(Panorama, _super);
            function Panorama() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Panorama.prototype.init = function (data, element) {
                _super.prototype.init.call(this, data, element);
                this.LayoutWidth = $dyn.ui.tabWidth(this);
                this.LayoutHeight = $dyn.ui.tabHeight(this);
                this.LayoutMinHeight = { minSizeFunction: $dyn.layout.gridLayoutMinHeight, cssClassArgument: "panoramaContainer" };
            };
            return Panorama;
        }($dyn.ui.Container));
        controls.Panorama = Panorama;
        Panorama.prototype.ShowHeaders = true;
        Panorama.prototype.Width = $dyn.layout.Size.available;
        Panorama.prototype.Height = $dyn.layout.Size.available;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Panorama.js.map
